import React from "react";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import ListAltIcon from "@mui/icons-material/ListAlt";
import DashboardIcon from "@mui/icons-material/Dashboard";
// import PriceChangeIcon from "@mui/icons-material/PriceChange";
import { privatePaths } from "router/paths";

export const Menu = [
  {
    name: "Dashboard",
    path: privatePaths.adminDashboard,
    icon: <DashboardIcon />,
    disabled: false,
  },
  {
    name: "Transaction Logs",
    path: privatePaths.transactionLogs,
    icon: <ListAltIcon />,
    disabled: false,
  },
  {
    name: "User Management",
    path: privatePaths.adminUserManagement,
    icon: <SupervisorAccountIcon />,
    disabled: false,
  },
  // {
  //   name: "Price Management",
  //   path: null,
  //   icon: <PriceChangeIcon />,
  //   disabled: false,
  // },
];
